import { render, staticRenderFns } from "./classroom-textbox-control.vue?vue&type=template&id=9bb0faf4&"
import script from "./classroom-textbox-control.vue?vue&type=script&lang=js&"
export * from "./classroom-textbox-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports